import { useSelector } from "react-redux";
import { Route, Routes } from "react-router-dom";
import { allowedTabs } from "../constants/permissionCatalog";
import ControlAppVersion from "../pages/dashboardPage/appVersionSettings/controlAppVersion/ControlAppVersion";

// Tab id (permissionCatalog "app-settings") → its page.
const TAB_PAGES = {
  "app-version": ControlAppVersion,
};

const AppVersionNavigator = () => {
  const { rolePermissions } = useSelector((state) => state.user);
  const tabs = allowedTabs("app-settings", rolePermissions);
  const FirstTab = tabs[0] ? TAB_PAGES[tabs[0].id] : null;

  return (
    <Routes>
      {tabs.map((tab) => {
        const Page = TAB_PAGES[tab.id];
        return <Route key={tab.id} path={`/${tab.path}`} element={<Page />} />;
      })}
      {FirstTab && <Route path="*" element={<FirstTab />} />}
    </Routes>
  );
};

export default AppVersionNavigator;
